import { render, staticRenderFns } from "./payWebview.vue?vue&type=template&id=0be05df9&"
import script from "./payWebview.vue?vue&type=script&lang=js&"
export * from "./payWebview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports